import type { ReactNode } from "react";

/**
 * A single figure with its label above it.
 *
 * Label first, value second — reading the label before the number is what makes
 * a row of tiles scannable. The value carries `tabular-nums` so digits do not
 * jitter as figures update.
 */
export function StatTile({
  label,
  value,
  hint,
  icon,
  tone = "default",
}: {
  label: string;
  value: string;
  hint?: string;
  icon?: ReactNode;
  tone?: "default" | "accent";
}) {
  return (
    <div className="card-hover rounded-xl border border-line/80 bg-card p-4 shadow-sm sm:p-5">
      <div className="flex items-start justify-between gap-2">
        <span className="text-xs font-medium text-muted-foreground">{label}</span>
        {icon && (
          <span
            className={`flex size-8 shrink-0 items-center justify-center rounded-lg ${
              tone === "accent"
                ? "bg-accent-50 text-accent-600 ring-1 ring-inset ring-accent-100"
                : "bg-ink-100 text-muted-foreground"
            }`}
          >
            {icon}
          </span>
        )}
      </div>
      <div className="tabular-nums mt-2.5 text-2xl font-semibold tracking-tight text-ink-900">{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-subtle">{hint}</div>}
    </div>
  );
}
